<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-input
        placeholder="请输入游戏包名称"
        v-model="searchValue"
        class="input-with-select search-input"
        @keydown.native.enter="searchGamePackageList"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchGamePackageList"
        ></el-button>
      </el-input>

      <div>
        <el-button type="primary" plain @click="exportGamePackage()"
          >导出</el-button
        >

        <el-button type="success" plain @click="gamePackageAddDialog"
          >游戏包新增</el-button
        >
      </div>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="80"> </el-table-column>
      <el-table-column prop="created_at" label="创建日期"> </el-table-column>
      <el-table-column prop="game.name" label="游戏名称"> </el-table-column>
      <el-table-column prop="name" label="游戏包名称"> </el-table-column>
      <el-table-column prop="os" label="机型类型">
        <template slot-scope="scope">
          <p v-if="scope.row.os == 1">Android</p>
          <p v-if="scope.row.os == 2">IOS</p>
          <p v-if="scope.row.os == 3">PC</p>
        </template>
      </el-table-column>
      <el-table-column prop="package_name" label="包名"> </el-table-column>
      <el-table-column prop="upload_status" label="上传状态"> </el-table-column>
      <el-table-column label="母包体积">
        <template slot-scope="scope">{{ scope.row.mb }}MB</template>
      </el-table-column>
      <el-table-column prop="uploaded_at" label="母包上传时间">
      </el-table-column>
      <el-table-column prop="version" label="当前版本"> </el-table-column>
      <el-table-column prop="currency" label="价格单位"> </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="warning"
            plain
            @click="gamePackageEditDialog(scope.row)"
            title=""
            >编辑</el-button
          >
          <el-button
            type="primary"
            plain
            @click="uploadButton(scope.row)"
            v-if="scope.row.os != 1"
            title=""
            >上传</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 新增游戏包对话框 -->
    <el-dialog
      title="新增游戏包"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addform"
        :rules="rules"
        label-width="100px"
        ref="addform"
      >
        <el-form-item label="所属游戏" prop="game_id">
          <el-select
            v-model="addform.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏包名称" prop="name">
          <el-input v-model="addform.name"></el-input>
        </el-form-item>
        <el-form-item label="游戏包包名" prop="package_name">
          <el-input v-model="addform.package_name"></el-input>
        </el-form-item>
        <el-form-item label="机型" prop="os">
          <el-radio-group v-model="addform.os">
            <el-radio :label="1">Android</el-radio>
            <el-radio :label="2">IOS</el-radio>
            <el-radio :label="3">PC</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格单位" prop="currency">
          <el-radio-group v-model="addform.currency">
            <el-radio label="CNY">CNY</el-radio>
            <el-radio label="USD">USD</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="隐私政策" prop="privacy">
          <wEditor ref="editorPrivacy" />
        </el-form-item>
        <el-form-item label="用户协议" prop="protocol">
          <wEditor ref="editorProtocol" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGamePackageSubmit('addform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑游戏包对话框 -->
    <el-dialog
      title="编辑游戏包"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editform"
        :rules="rules"
        label-width="100px"
        ref="editform"
      >
        <el-form-item label="所属游戏" prop="game_id">
          <el-select
            v-model="editform.game_id"
            filterable
            clearable
            placeholder="请选择"
            disabled
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏包名称" prop="name">
          <el-input v-model="editform.name"></el-input>
        </el-form-item>
        <el-form-item label="游戏包包名" prop="package_name">
          <el-input v-model="editform.package_name"></el-input>
        </el-form-item>
        <el-form-item label="版本号" v-if="os != 1">
          <el-input v-model="editform.version"></el-input>
        </el-form-item>
        <el-form-item label="隐私政策" prop="privacy">
          <wEditor ref="editorPrivacyE" :context="editform.privacy" />
        </el-form-item>
        <el-form-item label="用户协议" prop="protocol">
          <wEditor ref="editorProtocolE" :context="editform.protocol" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editGamePackageSubmit('editform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle } from "@/assets/js/public.js";
import { urlSplicing } from "@/assets/js/public.js";
import wEditor from '@/component/wEditor'

export default {
  name: "gamePackage",
  components: {
    wEditor
  },
  data() {
    return {
      limit: 1,

      loadingData: false,
      tableHeight: 0,
      vivi: false,
      searchValue: "",
      historyValue: "",
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      uploadDialogFormVisible: false,
      addform: {
        id: "",
        game_id: "",
        name: "",
        package_name: "",
        os: "",
        currency: "CNY",
      },
      editform: {
        id: "",
        game_id: "",
        name: "",
        package_name: "",
        version: "",
        privacy: "",
        protocol: "",
      },
      uploadform: "",
      os: "",
      rules: {
        name: [
          { required: true, message: "请输入游戏包名称", trigger: "blur" },
        ],
        package_name: [
          { required: true, message: "请输入游戏包包名", trigger: "blur" },
        ],
        game_id: [
          { required: true, message: "请选择所属游戏", trigger: "change" },
        ],
        os: [{ required: true, message: "请选择机型", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getGameSelectList();
    this.getGamePackageList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    ...mapMutations(["addTasks", "changeShowGamePackagesUploadTasks"]),
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGamePackageList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getGamePackageList(false);
    },

    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 实现游戏包数据的搜索
    searchGamePackageList() {
      this.currentPage = 1;
      this.getGamePackageList(true);
    },
    // 显示新增游戏对话框
    gamePackageAddDialog: throttle(function () {
      // 清空数据
      this.addform = {
        id: "",
        game_id: "",
        name: "",
        package_name: "",
        os: "",
        currency: "CNY",
      };
      // 这个方法执行的东西
      this.addDialogFormVisible = true;
    }, 1000),

    // 导出
    exportGamePackage() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/game_packages/list", params);
    },

    // 实现新增游戏包
    addGamePackageSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.addform
          }
          const privacy = this.$refs.editorPrivacy.html
          const protocol = this.$refs.editorProtocol.html
          if (privacy && privacy !== "<p><br></p>") {
            data.privacy = privacy
            this.$refs.editorPrivacy.html = ''
          }
          if (protocol && protocol !== "<p><br></p>") {
            data.protocol = protocol
            this.$refs.editorProtocol.html = ''
          }
          fetch({
            url: "/admin/game_packages/create",
            method: "POST",
            data,
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.getGamePackageList();
              this.addDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    // 编辑游戏包对话框--加载默认数据
    gamePackageEditDialog(row) {
      this.editform.id = row.id;
      this.editform.game_id = row.game_id;
      this.editform.name = row.name;
      this.editform.package_name = row.package_name;
      this.editform.version = row.version;
      this.editform.privacy = row.privacy
      this.editform.protocol = row.protocol
      this.os = row.os;
      this.editDialogFormVisible = true;
    },
    // 实现游戏包的编辑操作
    editGamePackageSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.editform
          }
          const privacy = this.$refs.editorPrivacyE.html
          const protocol = this.$refs.editorProtocolE.html
          if (privacy) data.privacy = privacy !== "<p><br></p>" ? privacy : ''
          if (protocol) data.protocol = protocol !== "<p><br></p>" ? protocol : ''
          fetch({
            url: "/admin/game_packages/update",
            method: "POST",
            data,
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.getGamePackageList();
              this.editDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    // 上传游戏包
    uploadButton(row) {
      // this.row = row;
      // this.vivi = true;
      // this.uploadDialogFormVisible = true;
      this.addTasks({
        taskId: new Date().getTime() + Math.floor(Math.random() * 1000 + 1),
        ...row,
        uploadStatus: 0, // 0 未上传 1上传中 2上传失败 3上传成功,
        action: "",
        uploadData: {},
      });
      this.changeShowGamePackagesUploadTasks(true);
    },
    // 展示游戏包列表数据
    getGamePackageList(reload = false) {
      let searchValue = "";
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/game_packages/list",
        method: "GET",
        params: {
          name: searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
